import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useRoleAccess } from '@/hooks/useRoleAccess';
import { Navigate } from 'react-router-dom';
import Header from '@/components/shared/Header';
import { Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import ContentCreatorDashboard from './ContentCreatorDashboard';

const ContentHub: React.FC = () => {
  const { user, loading } = useAuth();
  const { canCreateContent, canEditContent } = useRoleAccess();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user || !canCreateContent) {
    return <Navigate to="/auth/login" replace />;
  }

  // For pure contributors (no edit access), just show their dashboard
  if (!canEditContent) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <ContentCreatorDashboard />
        </div>
      </div>
    );
  }

  // For editors/admins, show content dashboard with a note about editorial access
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-8">
        {/* Info Alert for Editors */}
        {canEditContent && (
          <Alert className="mb-6">
            <Info className="h-4 w-4" />
            <AlertDescription>
              As an editor, you also have access to the{' '}
              <Button variant="link" className="p-0 h-auto" asChild>
                <Link to="/content">Editorial Dashboard</Link>
              </Button>
              {' '}for reviewing and managing content across the platform.
            </AlertDescription>
          </Alert>
        )}

        <ContentCreatorDashboard />
      </div>
    </div>
  );
};

export default ContentHub;
